// import React from "react";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );
// const dataa = [
//   {
//     Count: 13,
//     feedback: "Bad",
//     ClientCode: "11542",
//     Year: 2024,
//     Month: 6,
//   },
//   {
//     Count: 2,
//     feedback: "Good",
//     ClientCode: "11542",
//     Year: 2024,
//     Month: 6,
//   },
//   {
//     Count: 3,
//     feedback: "Very Good",
//     ClientCode: "11542",
//     Year: 2024,
//     Month: 6,
//   },
//   {
//     Count: 1,
//     feedback: "Bad",
//     ClientCode: "11542",
//     Year: 2024,
//     Month: 5,
//   },
//   {
//     Count: 1,
//     feedback: "Bad",
//     ClientCode: "11542",
//     Year: 2024,
//     Month: 4,
//   },
// ];
// const BasicBars = () => {
//   const data = {
//     labels: ["January", "February", "March"],
//     datasets: [
//       {
//         label: "BAD",
//         data: [55, 35, 35],
//         backgroundColor: "#F44336",
//         borderColor: "#F44336",
//         borderWidth: 1,
//       },
//       {
//         label: "GOOD",
//         data: [65, 59, 80],
//         backgroundColor: "#4CAF50",
//         borderColor: "#4CAF50",
//         borderWidth: 1,
//       },
//       {
//         label: "VERY GOOD",
//         data: [28, 48, 70],
//         backgroundColor: "#2E7D32",
//         borderColor: "#2E7D32",
//         borderWidth: 1,
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: "top",
//       },
//       title: {
//         display: true,
//         text: "Feed back",
//       },
//     },
//     scales: {
//       x: {
//         stacked: false, // Set to false to display separated bars
//       },
//       y: {
//         stacked: false, // Ensure y-axis is not stacked as well
//         beginAtZero: true,
//       },
//     },
//   };
//   const structureData = () => {
//     const labels = ['April', 'May', 'June']; // Labels for the last three months
//     const good = [0, 0, 0];
//     const bad = [0, 0, 0];
//     const veryGood = [0, 0, 0];

//     dataa.forEach(element => {
//       const monthIndex = element.Month - 4; // Adjust month to index (4: April, 5: May, 6: June)
//       if (element.feedback === "Bad") {
//         bad[monthIndex] += element.Count;
//       } else if (element.feedback === "Very Good") {
//         veryGood[monthIndex] += element.Count;
//       } else if (element.feedback === "Good") {
//         good[monthIndex] += element.Count;
//       }
//     });
//   return (
//     <div
//       style={{
//         width: "40%",
//         height: "280px",
//         display: "flex",
//         alignItems: "end",
//         justifyContent: "end",
//       }}
//     >
//       <div style={{ width: "100%", height: "100%" }}>
//         <Bar data={data} options={options} />
//       </div>
//     </div>
//   );
// };
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useUser } from "../Contexts/UserContext";
import { Button, CircularProgress, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/system";

// Register the necessary components with Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const API_URL = process.env.REACT_APP_DOMAIN_API_URL;

const BasicBars = () => {
  const [chartData, setChartData] = useState(null);
  const [rawData, setRawData] = useState();
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_URL}/facility/GetFeedBackData/3/GU-1/11542/UNTPFS00008511/1`
        ).then((res) => res.json());

        if (response.success) {
          setRawData(response.data);
          const structuredData = structureData(response.data);
          setChartData(structuredData);
        } else {
          alert(response.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const structureData = (data) => {
    const labels = ["April", "May", "June"]; // Labels for the last three months
    const good = [0, 0, 0];
    const bad = [0, 0, 0];
    const veryGood = [0, 0, 0];

    data.forEach((element) => {
      const monthIndex = element.Month - 4; // Adjust month to index (4: April, 5: May, 6: June)
      if (element.feedback === "Bad") {
        bad[monthIndex] += element.Count;
      } else if (element.feedback === "Very Good") {
        veryGood[monthIndex] += element.Count;
      } else if (element.feedback === "Good") {
        good[monthIndex] += element.Count;
      }
    });

    return {
      labels: labels,
      datasets: [
        {
          label: "BAD",
          data: bad,
          backgroundColor: "#F44336",
          borderColor: "#F44336",
          borderWidth: 1,
        },
        {
          label: "GOOD",
          data: good,
          backgroundColor: "#4CAF50",
          borderColor: "#4CAF50",
          borderWidth: 1,
        },
        {
          label: "VERY GOOD",
          data: veryGood,
          backgroundColor: "#2E7D32",
          borderColor: "#2E7D32",
          borderWidth: 1,
        },
      ],
    };
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      // title: {
      //   display: true,
      //   text: "Customer Feedback",
      // },
    },
    scales: {
      x: {
        stacked: false, // Set to false to display separated bars
      },
      y: {
        stacked: false, // Ensure y-axis is not stacked as well
        beginAtZero: true,
      },
    },
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  // Styled components
  const ChartContainer = styled(Box)({
    width: "100%",
    height: "280px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    padding: "16px",
    margin: "0 auto",
  });

  const TitleContainer = styled(Box)({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: "16px",
  });

  // Check if chartData is null before rendering the chart
  if (!chartData) {
    return (
      <Box
        sx={{
          display: "flex",
          height: "100vh",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ChartContainer>
      <TitleContainer>
        {/* <Typography variant="h6">Customer Feedback</Typography> */}
        {/* <Button
          variant="contained"
          color="primary"
          onClick={() => handleNavigation("/detail")}
        >
          Detail
        </Button> */}
      </TitleContainer>
      <Bar data={chartData} options={options} />
    </ChartContainer>
  );
};

export default BasicBars;
